import React from "react";
import { Briefcase } from "phosphor-react";
import { useTranslation } from "react-i18next";
const NoDataFound = () => {
  const { t } = useTranslation();
  return (
    <div
      className="d-flex justify-content-center align-items-center flex-column"
      style={{ height: "40vh" }}
    >
      <Briefcase size={62} className="mt-5 opacity-50" />
      <p className="opacity-50">{t("no-record-found")}</p>
    </div>
  );
};

export default NoDataFound;
